// Bölüm 2 (İSG): talebe özel tehlike sınıfı seçimi; önceki talepteki sınıf öneri olarak gösterilir
import { AlertTriangle, Check, Info } from 'lucide-react';
import { agendaStyle } from '../../settings/calendarViews';

export const HAZARD_OPTIONS = [
  ['az_tehlikeli', 'Az Tehlikeli', 'AT', '#16a34a'],
  ['tehlikeli', 'Tehlikeli', 'T', '#d97706'],
  ['cok_tehlikeli', 'Çok Tehlikeli', 'ÇT', '#dc2626'],
];
export const HAZARD = Object.fromEntries(HAZARD_OPTIONS.map(([k, l, s, c]) => [k, { label: l, short: s, color: c }]));

export const HazardClassPicker = ({ testId, title, value, suggestion, disabled, onChange }) => (
  <div className={`mb-4 rounded-xl border-2 p-4 transition-colors ${value ? 'border-slate-200 bg-white' : 'border-rose-300 bg-rose-50/50'}`}
    data-testid={testId} data-hazard-required={value ? undefined : 'true'}>
    <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
      <p className="font-semibold text-slate-900 flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-600" />{title} <span className="text-rose-500">*</span>
      </p>
      {suggestion
        ? <span className="text-xs rounded-full bg-sky-50 border border-sky-200 text-sky-700 px-2.5 py-1" data-testid={`${testId}-suggestion`}>Önceki talepte: <b>{HAZARD[suggestion]?.label}</b> (öneri)</span>
        : <span className="text-xs rounded-full bg-amber-100 border border-amber-300 text-amber-800 font-semibold px-2.5 py-1" data-testid={`${testId}-first-badge`}>İlk talep</span>}
    </div>
    {!suggestion && !value && (
      <div className="mb-3 flex items-start gap-2.5 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2.5 text-sm text-amber-900 animate-in fade-in" role="alert" data-testid={`${testId}-first-warning`}>
        <Info className="h-4 w-4 mt-0.5 shrink-0 text-amber-600" />
        <span><b>Bu firmanın tehlike sınıfı ilk kez belirlenecek.</b> Seçtiğiniz sınıf firma kaydına da işlenir ve sonraki taleplerde öneri olarak gelir; personelin İSG Eğitimi ve Sağlık Raporu geçerlilik süreleri buna göre hesaplanır. Lütfen dikkatle seçin.</span>
      </div>
    )}
    <div className="grid grid-cols-3 gap-2">
      {HAZARD_OPTIONS.map(([k, l, , c]) => {
        const on = value === k;
        return (
          <button key={k} type="button" disabled={disabled} onClick={() => !on && onChange(k)} data-testid={`${testId}-${k}`} aria-pressed={on}
            className={`flex items-center justify-center gap-2 rounded-lg border-2 px-3 py-2.5 text-sm font-medium transition-[background-color,border-color,transform] active:scale-[0.98] ${on ? 'text-base font-bold tracking-wide shadow-sm' : 'bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-60'}`}
            style={on ? agendaStyle({}, c) : { borderColor: suggestion === k ? c : '#e2e8f0', borderStyle: suggestion === k ? 'dashed' : 'solid' }}>
            {on && <Check className="h-5 w-5" strokeWidth={3} />}{l}
          </button>
        );
      })}
    </div>
    <p className="mt-2 text-xs text-slate-500">İSG Eğitimi ve Sağlık Raporu geçerlilik süreleri bu sınıfa göre hesaplanır. Önceki talepten farklı bir sınıf seçilirse bu talepteki personelin bu iki belgesi yeniden onaya düşer.</p>
  </div>
);
